<template>
  <div class="fixed z-20">
    <div class="flex h-screen">
      <!-- Sidebar Content -->
      <div
        class="transition-all duration-700 overflow-scroll hidden-scrollbar bg-white pt-12 md:pt-14 pb-16 md:pb-2"
        :class="[store.state.menu.sidebar.open ? 'w-60 sm:w-72' : 'w-0']"
      >
        <layouts-auth-sidebar-content />
      </div>

      <!-- Dimmer -->
      <transition name="fade">
        <div
          v-if="dimmer && store.state.menu.sidebar.open"
          @click="store.dispatch('menu/switchSidebarOpen')"
          class="bg-neutral-700 bg-opacity-50 w-screen"
        />
      </transition>
    </div>
  </div>

  <!-- Page Content -->
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useStore } from '@/store/index'

import LayoutsAuthSidebarContent from '@/components/LayoutsAuthSidebarContent.vue'

export default defineComponent({
  components: { LayoutsAuthSidebarContent },
  setup() {
    const store = useStore()
    const dimmer = ref(true)

    return {
      store,
      dimmer
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
